import { Amount } from "./amount";
import { InternalInvoiceItem } from "./internal-invoice";

export class BillingPreview {
  id: string = "";
  date: string = "";
  year: number = 0;
  month: number = 0;
  recoveredAmount!: Amount;
  amount!: Amount;
  items: InternalInvoiceItem[] = [];

  get yearMonth() {
    return `${this.year}/${this.month}`;
  }

  get monthLabel() {
    const date = new Date(this.year, this.month - 1, 1);
    return date.toLocaleDateString("en-US", { month: "long", year: "numeric" });
  }
}
